/*eslint-disable*/
import PropTypes from "prop-types";
import React from "react";

import ResponseMessage from "./messages/ResponseMessage";
import AcceptResponseSystemMessage from "./messages/AcceptResponseSystemMessage";
import ApprovedMarkAsResolvedMessage from "./messages/ApprovedMarkAsResolvedMessage";
import CustomerReroutePromptSystemMessage from "./messages/CustomerReroutePromptSystemMessage";
import CustomerReroutePromptBeforeClaimSystemMessage from "./messages/CustomerReroutePromptBeforeClaimSystemMessage";
import CustomerReroutePromptCustomSystemMessage from "./messages/CustomerReroutePromptCustomSystemMessage";
import ContestedMarkAsResolvedMessage from "./messages/ContestedMarkAsResolvedMessage";
import AutoResponseMessage from "./messages/AutoResponseMessage";
import AddTestimonialSystemMessage from "./messages/AddTestimonialSystemMessage";
import AddedTestimonialSystemMessage from "./messages/AddedTestimonialSystemMessage";
import AcceptedResponseSystemMessage from "./messages/AcceptedResponseSystemMessage";
import QuestionExpiredSystemMessage from "./messages/QuestionExpiredSystemMessage";
import QuestionReroutedSystemMessage from "./messages/QuestionReroutedSystemMessage";
import NotifyingExpertsSystemMessage from "./messages/NotifyingExpertsSystemMessage";
import RateResponseSystemMessage from "./messages/RateResponseSystemMessage";
import RejectedByUserBlockedQuestionSystemMessage from "./messages/RejectedByUserBlockedQuestionSystemMessage";
import MarkAsResolvedMessage from "./messages/MarkAsResolvedMessage";
import ContactInfoPromptSystemMessage from "./messages/ContactInfoPromptSystemMessage";
import ContactInfoConfirmSystemMessage from "./messages/ContactInfoConfirmSystemMessage";
import TranslationNoticeSystemMessage from "./messages/TranslationNoticeSystemMessage";
import ChatPropTypes from "./ChatPropTypes";

import MessageType from "../../constants/ChatMessageTypes";

export const MessageContainer = ({ disableAskNewQuestionFromUi, message, question, response, scrollToBottom }) => {
    const showAskNewQuestionMessage = !disableAskNewQuestionFromUi;

    switch (message.type) {
        case MessageType.AutoResponseMessage:
            return (
                <AutoResponseMessage
                    author={message.author}
                    companyName={question.company}
                    responseMessageAuthor={response.responseMessageAuthor}
                    dateCreated={message.dateCreated}
                    id={message.id}
                    messageTextHtml={message.messageTextHtml}
                    showChatbotNameAndAvatar={response.showChatbotNameAndAvatar}
                    viewedByUser={message.viewedByUser}
                    messageType={message.type}
                />
            );
        case MessageType.CustomerReroutePromptSystemMessage:
            return (
                <CustomerReroutePromptSystemMessage
                    question={question}
                    companyName={question.company}
                    response={response}
                />
            );
        case MessageType.CustomerReroutePromptBeforeClaimSystemMessage:
            return <CustomerReroutePromptBeforeClaimSystemMessage question={question} />;
        case MessageType.CustomerReroutePromptCustomSystemMessage: {
            const messageActions = message.actions.map(({ link, text }) => ({
                label: text,
                intent: link,
            }));

            return (
                <CustomerReroutePromptCustomSystemMessage
                    messageActions={messageActions}
                    messageText={message.messageText}
                />
            );
        }
        case MessageType.AcceptedResponseSystemMessage:
            return <AcceptedResponseSystemMessage showAskNewQuestionMessage={showAskNewQuestionMessage} />;
        case MessageType.QuestionExpiredSystemMessage:
            return <QuestionExpiredSystemMessage showAskNewQuestionMessage={showAskNewQuestionMessage} />;
        case MessageType.QuestionFlagSystemMessage:
        case MessageType.QuestionRejectedByKeywordSystemMessage:
        case MessageType.QuestionRejectedByMetadataSystemMessage:
        case MessageType.QuestionRejectedByPredictiveRoutingSystemMessage:
        case MessageType.QuestionRejectedByDomainSystemMessage:
        case MessageType.QuestionRejectedByBudgetSystemMessage:
        case MessageType.QuestionReroutedSystemMessage: {
            const messageActions = message.actions.map(({ link, text }) => ({
                label: text,
                intent: link,
            }));

            return (
                <QuestionReroutedSystemMessage
                    messageActions={messageActions}
                    messageText={message.messageText}
                    showAskNewQuestionMessage={showAskNewQuestionMessage}
                    question={question}
                />
            );
        }
        case MessageType.RejectedByUserBlockedQuestionSystemMessage:
            return <RejectedByUserBlockedQuestionSystemMessage question={question} message={message} />;
        case MessageType.AddTestimonialSystemMessage:
            return <AddTestimonialSystemMessage response={response} />;
        case MessageType.AddedTestimonialSystemMessage:
            return <AddedTestimonialSystemMessage response={response} />;
        case MessageType.AcceptResponseSystemMessage:
            return <AcceptResponseSystemMessage question={question} response={response} />;
        case MessageType.NotifyingExpertsSystemMessage:
            return <NotifyingExpertsSystemMessage question={question} />;
        case MessageType.RateResponseSystemMessage:
            return <RateResponseSystemMessage />;
        case MessageType.MarkAsResolvedMessage:
            return message.customerRepliedToMarkAsResolved ? (
                <MarkAsResolvedMessage recognitionRecipient={response.recognitionRecipient} />
            ) : null; // in this case the message is rendered as a confirmation message (ConfirmationMessageContainer), so it is ignored here
        case MessageType.ContestedMarkAsResolvedMessage:
            return <ContestedMarkAsResolvedMessage recognitionRecipient={response.recognitionRecipient} />;
        case MessageType.ApprovedMarkAsResolvedMessage:
            return <ApprovedMarkAsResolvedMessage />;
        case MessageType.ContactInfoPromptSystemMessage:
            return <ContactInfoPromptSystemMessage questionUuid={question.uuid} />;
        case MessageType.ContactInfoConfirmSystemMessage:
            return <ContactInfoConfirmSystemMessage message={message} scrollToBottom={scrollToBottom} />;
        case MessageType.TranslationNoticeSystemMessage:
            return <TranslationNoticeSystemMessage text={message.messageText} />;
        default:
            return (
                <ResponseMessage
                    author={message.author}
                    dateCreated={message.dateCreated}
                    id={message.id}
                    isFirstResponseMessage={message.isFirstResponseMessage}
                    isLoading={message.isLoading}
                    messageText={message.messageText}
                    showChatbotNameAndAvatar={response.showChatbotNameAndAvatar}
                    scrollToBottom={scrollToBottom}
                />
            );
    }
};

MessageContainer.propTypes = {
    disableAskNewQuestionFromUi: PropTypes.bool.isRequired,
    message: ChatPropTypes.message.isRequired,
    question: ChatPropTypes.question.isRequired,
    response: ChatPropTypes.response.isRequired,
    scrollToBottom: PropTypes.func.isRequired,
};

export default MessageContainer;
